import React, { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { useTheme } from '@mui/material';
import { useSelector } from 'react-redux';
import axios from 'axios';
import Pagination from "react-js-pagination";
import { useNavigate } from 'react-router-dom';
import { TbLoader } from 'react-icons/tb';

const useStyles = makeStyles((theme) => ({    
      orderListBlock:{
        //padding:'30px 0px 0px 0px',
        position:'relative',
    
        fontFamily:[
          'Noto Sans KR'
        ],
        
      },
      row:{
        maxWidth:'1280px', 
        margin:'0 auto', 
        padding:'270px 0px 50px 0px',
        
        fontFamily:[
          'Noto Sans KR'
        ],
  
        [theme.breakpoints.down(1025)]: {
          padding:'150px 0 0px 0',
        }
      },
      orderListH1:{ 
        fontSize:'35px', 
        textAlign:'center', 
      },
      orderListBox: props => ({
        //maxWidth: props.maxWidth,
        maxWidth:'1280px',
        margin:'0 auto', 
        padding:'40px 0px 0px 0px',
        display: 'flex',
        flexDirection: 'column',
      }),
      Titles: {
        display: 'flex',
        flex: 1,
        justifyContent: 'center',
        alignItems: 'center',
        borderTop: '2px solid #007235',
        borderBottom: '2px solid #CCCCCC',
        paddingTop: 12,
        paddingBottom: 12,
    
        [theme.breakpoints.down(1025)]: {
          borderBottom:'none',
          paddingTop: 0,
    
        },
    
      },
      TitlesItem: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        fontWeight: 300,
    
        [theme.breakpoints.down(1025)]: {
          display:'none',
        },
    
      },
      orderItems: {
        display: 'flex',
        flexDirection: 'column',
        flex: 1,
        justifyContent: 'center',
        alignItems: 'center',
      },
      innerClass: {
        display: 'flex',
        justifyContent: 'center',
        marginTop: '50px',
        listStyle: 'none',
        padding: 0,
      },
      itemClass: {
        display: 'inline-block',
        width: '36px',
        height: '30px',
        border: '1px solid #CCC',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        fontSize: '1rem',
      },
      itemClassFirst: {
        //borderRadius: '15px 0 0 15px',
      },
      itemClassLast: {
        //borderRadius: '0 15px 15px 0',
      },
      linkClass: {
        textDecoration: 'none',
        //color: '#007235',
        fontSize: '0.8rem',
      },
      activeClass: {
        backgroundColor: '#007235'
      },
      activeLinkClass: {
        color: 'white',
      },
      load:{
        display:'flex',
        justifyContent:'center',
        alignItems:'center',
      },
      loadingIcon:{
        color:'#007235',
        fontSize:'50px',
        animation:'$loadSpin 5s infinite'
      },
      "@keyframes loadSpin":{
        from: { transform:'rotate(0deg)' },
        to: { transform:'rotate(1turn)' }
      },

}))

const OrderList = () => {
    let navigate = useNavigate();
    const theme = useTheme();
    const classes = useStyles(theme);
    const mbId = useSelector(state => state.user.userInfo['mb_id']);
    const login = useSelector(state => state.user.login);
    const [data, setData] = useState([])
    const [itemList, setItemList] = useState([])
    const [page, setPage] = useState(1);
    const [loading, setLoading] = useState(false)

    useEffect(() => {
      window.scrollTo(0, 0);
    }, [])

    useEffect(() => {
      if (!login) {
        navigate("/");
      }
    } , [login])

    const getItem = async() => {
        try {
          setLoading(true)
            const res = await axios.post('/api/shop/getMyOrderList/', {mb_id: mbId})

            if(res.data.success === false) {
                alert('불러오기 실패')
                setLoading(false)
                return;
            }
            setData(res.data.result)
            setLoading(false)
        
          } catch (e) {
            console.log(e)
            setLoading(false)
          }
    }

    useEffect(() => {
        if (mbId) {
            getItem()
        }
    } ,[mbId])

    useEffect(() => {
        setItemList(data.slice((15 * page ) - 15, (15 * page )))
      }, [page, data])

    const handlePageChange = (page) => {
      setPage(page);
    };

    useEffect(() => {

      return () => {
        setData([])
      }
    }, [])

    return (
        <div className={classes.orderListBlock}>
            <div className={classes.row}>
                <h1 className={classes.orderListH1}>주문 목록</h1>
                { loading ? (
                    <div className={classes.load}>
                      <TbLoader className={classes.loadingIcon}/>
                    </div>
                ) : (
                  <div className={classes.orderListBox}>
                    <div className={classes.Titles}>
                        <h1 className={classes.TitlesItem} style={{flex: 1, fontWeight: 'bold'}}>주문번호</h1>
                        <h1 className={classes.TitlesItem} style={{flex: 1, fontWeight: 'bold'}}>주문일자</h1>
                        <h1 className={classes.TitlesItem} style={{flex: 1, fontWeight: 'bold'}}>주문금액</h1>
                        <h1 className={classes.TitlesItem} style={{flex: 0.5, fontWeight: 'bold'}}>주문상태</h1>
                        <h1 className={classes.TitlesItem} style={{flex: 1, fontWeight: 'bold'}}>상품</h1>
                    </div>
                    <div className={classes.orderItems}>
                        {itemList.length > 0 &&  itemList.map((item) => (
                                        <OrderItm 
                                            key={item['od_id']}
                                            odId={item['od_id']}
                                            odCartPrice={item['od_cart_price']}
                                            odStatus={item['od_status']}
                                            odTime={item['od_time']}
                                            items={item['items']}
                                        />
                        ))}
                    </div>
                    <Pagination
                        activePage={page}
                        itemsCountPerPage={15}
                        totalItemsCount={data.length}
                        pageRangeDisplayed={5}
                        prevPageText={"‹"}
                        nextPageText={"›"}
                        onChange={handlePageChange}
                        className={classes.navi}
                        innerClass={classes.innerClass}    //안에?
                        itemClass={classes.itemClass}      //아이템들?
                        itemClassFirst={classes.itemClassFirst}    //first?
                        itemClassLast={classes.itemClassLast}     // last
                        linkClass={classes.linkClass}        // 아이템 링크
                        activeClass={classes.activeClass}        // 현재페이지
                        activeLinkClass={classes.activeLinkClass}     // 현제페이지 링크
                    />
                  </div>
                )}

            </div>
        </div>
    )
}


const useStylesOrderItem = makeStyles((theme)=>({
  ItemBox: {
    display: 'flex',
    width: '100%',
    flexDirection: 'row',
    alignItems: 'center',
    borderBottom: '2px solid #ccc',
    paddingTop: 12,
    paddingBottom: 12,
    color:'#555555',
    cursor: 'pointer',
    [theme.breakpoints.down(1025)]: {
      flexDirection: 'column',
      alignItems: 'stretch',
    },
  },
  orderItem: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    fontWeight: 400,
    fontSize:'14px',
    '&:first-child':{ 
      width:'22%',
    },
    '&:nth-child(2)':{ 
      width:'23%',
    },
    '&:nth-child(3)':{ 
      width:'21%',
    },
    '&:nth-child(4)':{ 
      width:'12%',
    },
    '&:last-child':{ 
      width:'22%',
    },

    [theme.breakpoints.down(1025)]: {
      '&:first-child':{ 
        width:'100%'
      },
      '&:nth-child(2)':{ 
        width:'100%'
      },
      '&:nth-child(3)':{ 
        width:'100%'
      },
      '&:nth-child(4)':{ 
        width:'100%'
      },
      '&:last-child':{ 
        width:'100%'
      },
    },
  },
  
  }));

const OrderItm = ({
    odId,
    odCartPrice,
    odStatus,
    odTime,
    items}) => {
    let navigate = useNavigate();
    const theme = useTheme();
    const classes = useStylesOrderItem(theme);

    return (
        <div 
          className={classes.ItemBox}
          onClick={() => {
            navigate("/OrderListDetail", {
              state: { odId: odId }
            });
          }}
        >
            <h3 className={classes.orderItem}>
              {odId}
            </h3>
            <h3 className={classes.orderItem}>
              {odTime.substr(0, 10)}
            </h3>
            <h3 className={classes.orderItem}>
              {odCartPrice.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}원
            </h3>
            <h3 className={classes.orderItem}>
              {odStatus}
            </h3>
            <h3 className={classes.orderItem}>
              {items[0]} 외 {items.length - 1} 개
            </h3>
        </div>
    );
}



export default OrderList
